<template>
  <div class="post" :data-postid="post.shortcode" @click="$emit('click')">
    <img class="preview" :src="post.previewPic" />
    <img v-if="post.postType === 'InstaVideo'" class="btn-video" src="~images/project/play-icon.svg" />
    <div v-if="post.postType === 'InstaGallery'" class="album-icon"><img src="~images/project/album.svg" /></div>
    <div class="user">
      <img v-if="post.profilePic" :src="post.profilePic"/>
      <div class="detail">
        <span v-html="post.name"></span>
        <span v-if="post.designation" v-html="post.designation"></span>
      </div>
    </div>
    <div class="text" v-if="post.captions.length" v-html="truncateStr(post.captions)" />
  </div>
</template>

<script>
import _truncate from 'lodash/truncate'

export default {
  props: ['post'],
  methods: {
    truncateStr (texts) {
      // const str = texts.reduce((acc, captionText) => acc + '<br>' + captionText, '')
      const str = texts.reduce((acc, captionText) => {
        acc += ' ' + captionText
        return acc
      }, '')
      return _truncate(str, {
        length: 200,
        separator: ' ',
        omission: ' ...'
      })
    }
  }
}
</script>

<style lang="scss">
.post {
  width: 100%;
  height: 480px;
  display: inline-block;
  padding: 30px 10px;
  overflow: hidden;
  max-width: 300px;
  position: relative;
  text-align: left;
  cursor: pointer;
  vertical-align: top;

  &:hover {
    .btn-video {
      opacity: 1;
    }
  }

  .preview {
    width: 300px;
    height: 300px;
    object-fit: cover;
    border-radius: 10px;
  }

  .btn-video {
    position: absolute;
    left: 50%;
    top: 150px;
    width: 60px;
    transform: translateX(-50%);
    opacity: 0.6;
    transition: opacity .15s ease-out;
  }

  .album-icon {
    position: absolute;
    top: 35px;
    right: 20px;
    font-weight: bold;
    width: 25px;
  }

  .user {
    display: block;
    padding: 10px 0;

    & > * {
      display: inline-block;
      vertical-align: top;
    }

    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      padding-right: 10px;
    }

    .detail {
      width: calc(100% - 60px);

      span {
        font-family: $font-CuratorBold;
        font-size: 16px;
        color: #333;
        // display: block;
        &:nth-child(2) {
          display: block;
          font-family: $font-CuratorRegular;
          font-size: 15px;
          color: #666666;
          clear: both;
        }
      }
    }
  }

  .text {
    position: relative;
    display: block;
    font-size: 16px;
    color: #333;
    font-family: $font-CuratorRegular;
    word-break: break-word;

    &::after {
      position: absolute;
      content: '';
      bottom: 0;
      left: 0;
      width: 100%;
      height: 20px;
      background: linear-gradient(to bottom, rgba(white, 0) 0%, white 100%);
    }
  }
}
</style>
